/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from "react";
import { getPresentationById } from "./apiEvents";
import { isAuthenticated } from "../auth";
import {
    Container,
    Box,
    Grid,
    Typography,
    Paper,
    Breadcrumbs,
    Link as MuiLink,
    Card,
    CardContent,
    Button,
    Chip,
    Divider
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import PresentationIcon from '@mui/icons-material/Slideshow';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DownloadIcon from '@mui/icons-material/Download';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ReactPlayer from 'react-player';
import Footer from '../core/Footer';
import Ampirical from '../images/Ampirical_web.png';
// import chattxt from 'https://s3.console.aws.amazon.com/s3/object/sdsic-images?region=us-east-1&prefix=MonthlyMeetingVideos/Technology/TechCommitteeMonthly_feb_09_22.json';


class Presentation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            presentation: {},
            presentationId: this.props.match.params.presentationId,
            eventId: null
        };
    }

    token = isAuthenticated() && isAuthenticated().token;


    componentDidMount() {

        // this.setState({ userId: isAuthenticated().userId})

        getPresentationById(this.props.match.params.presentationId, this.token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                console.log(data)

                this.setState({
                    presentation: data[0],
                    eventId: data[0].eventId._id
                });

            }
        });

    }


    render() {
        const { presentation, eventId } = this.state;

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <PresentationIcon sx={{ fontSize: 56 }} />
                            <Box sx={{ flex: 1 }}>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 1 }}>
                                    {presentation.title}
                                </Typography>
                                <Typography variant="h6" sx={{ opacity: 0.9, lineHeight: 1.4 }}>
                                    {presentation.description}
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="lg">
                    {/* Breadcrumbs */}
                    <Breadcrumbs
                        separator={<NavigateNextIcon fontSize="small" />}
                        sx={{ mb: 3 }}
                    >
                        <MuiLink underline="hover" color="inherit" href="/">
                            Home
                        </MuiLink>
                        <MuiLink underline="hover" color="inherit" href={`/showcaseEvent/${eventId}`}>
                            Back to Event
                        </MuiLink>
                        <Typography color="text.primary">{presentation.title}</Typography>
                    </Breadcrumbs>

                    <Grid container spacing={3}>
                        {/* Left Column - Presenter Info */}
                        <Grid item xs={12} md={4}>
                            {/* Main Presenter Card */}
                            {presentation.presenter && (
                                <Card elevation={3} sx={{ mb: 3, borderRadius: 3 }}>
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                            <PersonIcon sx={{ color: '#003E7E' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                Presented by
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ mb: 2 }} />

                                        <MuiLink
                                            href={`/user/${presentation.presenter._id}`}
                                            underline="hover"
                                            sx={{ display: 'block', mb: 1 }}
                                        >
                                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                {presentation.presenter.name} {presentation.presenter.lastName}
                                            </Typography>
                                        </MuiLink>

                                        {presentation.presenter.about && (
                                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                                                {presentation.presenter.about}
                                            </Typography>
                                        )}

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <EmailIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.presenter.email}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <BusinessIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.presenter.companyName}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}

                            {/* Co-Presenter Card */}
                            {presentation.copresenter && (
                                <Card elevation={3} sx={{ mb: 3, borderRadius: 3 }}>
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                            <PersonIcon sx={{ color: '#FF6600' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#FF6600' }}>
                                                Co-Presented by
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ mb: 2 }} />

                                        <MuiLink
                                            href={`/user/${presentation.copresenter._id}`}
                                            underline="hover"
                                            sx={{ display: 'block', mb: 1 }}
                                        >
                                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                {presentation.copresenter.name} {presentation.copresenter.lastName}
                                            </Typography>
                                        </MuiLink>

                                        {presentation.copresenter.about && (
                                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                                                {presentation.copresenter.about}
                                            </Typography>
                                        )}

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <EmailIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.copresenter.email}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <BusinessIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.copresenter.companyName}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}

                            {/* Guest Card */}
                            {presentation.guest && (
                                <Card elevation={3} sx={{ mb: 3, borderRadius: 3 }}>
                                    <CardContent sx={{ p: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                            <PersonIcon sx={{ color: '#003E7E' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                                Guest
                                            </Typography>
                                        </Box>
                                        <Divider sx={{ mb: 2 }} />

                                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E', mb: 1 }}>
                                            {presentation.guest.name} {presentation.guest.lastName}
                                        </Typography>

                                        {presentation.guest.about && (
                                            <Typography variant="body1" sx={{ mb: 2, fontWeight: 500 }}>
                                                {presentation.guest.about}
                                            </Typography>
                                        )}

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <EmailIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.guest.email}
                                            </Typography>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <BusinessIcon sx={{ fontSize: 18, color: '#666' }} />
                                            <Typography variant="body2" color="text.secondary">
                                                {presentation.guest.companyName}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>
                            )}

                            {/* Date & Download Card */}
                            <Card elevation={3} sx={{ borderRadius: 3 }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                        <CalendarMonthIcon sx={{ color: '#003E7E' }} />
                                        <Typography variant="body1" color="text.secondary">
                                            Presented on
                                        </Typography>
                                    </Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
                                        {presentation.datePresented}
                                    </Typography>

                                    {presentation.download && (
                                        <Button
                                            href={presentation.download}
                                            target="_blank"
                                            rel="noreferrer"
                                            variant="contained"
                                            startIcon={<DownloadIcon />}
                                            fullWidth
                                            sx={{
                                                backgroundColor: '#FF6600',
                                                '&:hover': {
                                                    backgroundColor: '#e55a00',
                                                }
                                            }}
                                        >
                                            Download Meeting Chat
                                        </Button>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Right Column - Video Player */}
                        <Grid item xs={12} md={8}>
                            <Paper
                                elevation={3}
                                sx={{
                                    borderRadius: 3,
                                    overflow: 'hidden',
                                    backgroundColor: '#000'
                                }}
                            >
                                <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
                                    <Box sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                                        <ReactPlayer
                                            config={{
                                                file: {
                                                    attributes: {
                                                        onContextMenu: e => e.preventDefault(),
                                                        controlsList: 'nodownload'
                                                    }
                                                }
                                            }}
                                            url={presentation.video}
                                            width='100%'
                                            height='100%'
                                            controls={true}
                                        />
                                    </Box>
                                </Box>
                            </Paper>

                            {/* Video Info */}
                            <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <PlayCircleIcon sx={{ color: '#003E7E' }} />
                                <Typography variant="body2" color="text.secondary">
                                    Use the controls to play, pause, and adjust volume
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                <Box sx={{ mt: 6 }}>
                    <Footer />
                </Box>
            </>
        );
    }
}

export default Presentation;
